import { Pipe, PipeTransform } from '@angular/core';
import { EditableNumberField, isNumberFieldOutOfRange } from './seg-number-field-bounds';

@Pipe({ name: 'fieldOutOfRange', standalone: true })
export class FieldOutOfRangePipe implements PipeTransform {
  transform(value: number | null | undefined, field: EditableNumberField): boolean {
    return isNumberFieldOutOfRange(value, field);
  }
}
